import React, { useContext } from "react";
import { AccountFeedbackContext } from "@sbi-international/boutik.gatsby.plugin.account/dist/src/contexts/AccountFeedbackContext";
import { CheckoutFeedbackProvider } from "@sbi-international/boutik.gatsby.plugin.checkout";

import { FeedbackContext } from "./feedbackContext";

export interface FeedbackProviderWrapperProps {
  children: React.ReactNode;
}

export const FeedbackProviderWrapper: React.FC<FeedbackProviderWrapperProps> = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const feedbackContextMethods = useContext(FeedbackContext);

  return (
    <AccountFeedbackContext feedbackContext={feedbackContextMethods}>
      <CheckoutFeedbackProvider feedbackContext={feedbackContextMethods}>{children}</CheckoutFeedbackProvider>
    </AccountFeedbackContext>
  );
};
